import { IChallangeData } from 'shared/types/challenges.interface';

export enum EDebateStatuses {
  Scheduled = 'scheduled',
  InProgress = 'in_progress',
  Failed = 'failed',
  Left = 'leaved',
  Finished = 'finished',
  Deleted = 'deleted',
}

export type TDebateStatus =
  | EDebateStatuses.Scheduled
  | EDebateStatuses.InProgress
  | EDebateStatuses.Failed
  | EDebateStatuses.Finished
  | EDebateStatuses.Left
  | EDebateStatuses.Deleted;

type TDebateSchedule = {
  id: number;
  start_datetime: number;
  end_datetime: number;
  poll_start_datetime: number;
  poll_end_datetime: number;
  initiator_entry: boolean;
  opponent_entry: boolean;
  created_at: number;
  challenge: number;
};

export enum ERoundStatuses {
  Active = 'active',
  NotStarted = 'not_started',
  Completed = 'completed',
}

export interface IDebateRound {
  id: number;
  global_round_number: number;
  speaker_round_number: number;
  debate: number;
  status: ERoundStatuses.Active | ERoundStatuses.NotStarted | ERoundStatuses.Completed;
  start_time: string | number;
  end_time: string | number;
  owner: number;
}

export interface IDebateData {
  id: number;
  challenge: IChallangeData;
  debate_schedule: TDebateSchedule;
  created_at: number;
  status: TDebateStatus;
  rounds: IDebateRound[];
  recording_url: string | null;
  recording_duration_seconds: number | null;
  recording_file_size_mb: number | null;
  recording_duration_formatted: string | null;
}

export interface ICancelDebateRequest {
  id: number;
  message: string;
}

export interface IEndDebateRequest {
  id: string | number;
  message: string;
  status?: TDebateStatus;
}
